import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
const SvgLogoCosmonic = (props)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "currentColor",
        viewBox: "0 0 81.97 93.65",
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
            d: "M38.92 72.16c-4.7-12.57-10.87-18.69-23.5-23.39a2.08 2.08 0 0 1 0-3.9c12.63-4.69 18.8-10.82 23.5-23.39a2.06 2.06 0 0 1 3.92.12c3.8 12.69 8.19 21.32 37 21.87A2.07 2.07 0 0 0 82 41.41V27.12a7.41 7.41 0 0 0-3.67-6.41L44.72 1a7.4 7.4 0 0 0-7.47 0L3.67 20.71A7.45 7.45 0 0 0 0 27.13v39.43A7.43 7.43 0 0 0 3.68 73l33.58 19.64a7.36 7.36 0 0 0 7.45 0L78.3 73a7.45 7.45 0 0 0 3.7-6.44v-14.3a2.08 2.08 0 0 0-2.11-2.08C51 50.73 46.63 59.36 42.84 72a2.06 2.06 0 0 1-3.92.16"
        })
    });
const logo_cosmonic_rslib_entry_ = SvgLogoCosmonic;
export { logo_cosmonic_rslib_entry_ as default };

//# sourceMappingURL=logo-cosmonic.js.map